import React from 'react';
import styled from 'styled-components';

const Title = styled.h3`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 20px;
    font-family: ${props => props.theme.font.family};
    font-size: ${props => props.theme.font.size.large};
    font-style: ${props => props.theme.font.style};
    font-weight: ${props => props.theme.font.weight.regular};
`;

const Input = styled.input`
    width: 100%;
    padding: 15px;
    resize: none;
    margin: 5px;
    display: inline-block;  
    outline: 0;
    background: #f2f2f2;
    border: 0;
    border-radius: .25rem;
    box-sizing: border-box;
`;

const LoginFormContainer = styled.form`
    position: relative;
    margin: 0 auto 100px;
    text-align: center;
`;

const Button = styled.button`
    text-transform: uppercase;
    outline: 0;
    background: #3CAB3D;
    width: 100%;
    border: 0;
    padding: 15px;
    color: #FFFFFF;
    font-size: 14px;
    -webkit-transition: all 0.3 ease;
    transition: all 0.3 ease;
    cursor: pointer;
    border: none;
    border-radius: .25rem;
    padding: 15px 32px;  
    margin: .5rem;  
    margin-top: 2rem;
    text-align: center;  
    text-decoration: none;  
    display: inline-block;  
    font-size: 16px;  

  &:hover {
      background: #43A047;
  }
`;

const Message = styled.p`
  margin: 15px 0 0;
  color: #b3b3b3;
    font-size: ${props => props.theme.font.size.small};
    &:a {
      color: #4CAF50;
      text-decoration: none;
    }
`;

const ListItem = styled.li`
    text-align: left;
    padding-bottom: 1rem;
`;

interface LoginFormProps {
    email: string;
    setEmail: (email: string) => void;
    emailError: string;
    setEmailError: (error: string) => void;
    loginError: string;
    password: string;
    setPassword: (password: string) => void;
    clickLogin: (e: React.FormEvent) => void;
    setFormState: (state: 'login' | 'register' | 'changePassword') => void;
}

const LoginForm: React.FC<LoginFormProps> = ({ email, setEmail, emailError, setEmailError, loginError, password, setPassword, clickLogin, setFormState }) => {
    return (
        <LoginFormContainer>
            <Title>Login to Online Police Reports</Title>
            <ul>
                <ListItem>Your Logon ID will be the e-mail address you provided when registering.</ListItem>
                <ListItem>If you have forgotten your password, click here to have a new one emailed to you.</ListItem>
            </ul>
            {emailError && <Message>{emailError}</Message>}
            {loginError && <Message>{loginError}</Message> }
            <Input
                type="text"
                value={email}
                onChange={(e) => {
                    setEmail(e.target.value);
                    setEmailError("");
                }}
                placeholder="Email"
            />
            <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
            />
            <Button onClick={clickLogin}>
                Login
            </Button>
            <Message>
                Not registered? <a href="#" onClick={() => setFormState('register')}>Register</a>
            </Message>
            <Message>
                Forgot password? <a href="#" onClick={() => setFormState('changePassword')}>Change Password</a>
            </Message>
        </LoginFormContainer>
    );
};

export default LoginForm;
